import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Badge,
  FormGroup,
} from "reactstrap"
import TimePicker from "react-time-picker"

import { map, forEach } from "lodash"
import Select from "react-select"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import * as Yup from "yup"
import { useFormik } from "formik"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import {
  seasonPasstSatusTypes,
  seasonTypes,
  messageTitle,
  vehicleTypes,
} from "constants/common"
import { getRoles as onGetRoles } from "../../store/roles/actions"
import { getCarParks as onGetCarparks } from "../../store/carpark/actions"
import { dateformat } from "config"
import moment from "moment-timezone"
import Switch from "react-switch"
import OffSymbol from "components/Common/OffSymbol"
import OnSymbol from "components/Common/OnSymobl"
//Import Breadcrumb
import DeleteModal from "components/Common/DeleteModal"
import { convertUtcToLocal, convertDateToUtc } from "../../helpers/util"
import {
  getSeasonPasses as onGetSeasonPasses,
  addNewSeasonPass as onAddNewSeasonPass,
  updateSeasonPass as onUpdateSeasonPass,
  deleteSeasonPass as onDeleteSeasonPass,
  clearMessage,
} from "../../store/season-pass/actions"
import { isEmpty } from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

//redux
import { useSelector, useDispatch } from "react-redux"

const getColor = status => {
  if (status == seasonPasstSatusTypes.Removed) {
    return "danger"
  } else if (
    status == seasonPasstSatusTypes.Approved ||
    status == seasonPasstSatusTypes.Available
  ) {
    return "success"
  } else if (status == "Not-Available") {
    return "dark"
  } else {
    return "warning"
  }
}

const defaultDate = moment()
const defaultExpiryDate = moment().add(1, "days")
const getSeasonType = seasonPass => {
  if (!isEmpty(seasonPass)) {
    return {
      value: seasonPass?.seasonType || "",
      label: seasonPass?.seasonType || "",
    }
  }
  return null
}

const getSelectedRoles = seasonPass => {
  let list = []
  if (!isEmpty(seasonPass)) {
    forEach(seasonPass?.roles || [], el => {
      list.push({
        value: el?._id || "",
        label: el?.roleTitle || "",
      })
    })
  }
  return list
}

const getSelectedSeasonPass = seasonPass => {
  let list = []

  if (!isEmpty(seasonPass)) {
    forEach(seasonPass?.carparks || [], el => {
      list.push({
        value: el?._id || "",
        label: el?.carParkTitle || "",
      })
    })
  }

  return list.length > 0 ? list : null
}

const getScheduleDate = seasonPass => {
  if (!isEmpty(seasonPass)) {
    const schedule = seasonPass?.scheduled || null
    if (schedule) {
      return schedule[0].dateScheduled
    }
  }
  return defaultDate
}

const getScheduleChangeDate = seasonPass => {
  if (!isEmpty(seasonPass)) {
    const schedule = (seasonPass?.scheduled || []).find(
      el => el.updateField == "seasonTitle"
    )
    if (schedule && !isEmpty(schedule)) {
      return schedule.dateScheduled
    }
  }
  return defaultDate
}
const sizePerPage = 25

const SeasonPassList = props => {
  const dispatch = useDispatch()
  const [type, setType] = useState(vehicleTypes.car)
  const [seasonPass, setSeasonPass] = useState(null)
  const [expiryStatus, setExpiryStatus] = useState(false)
  const [price, setPricing] = useState(0)
  const [filterStatus, setFilterStatus] = useState({
    value: "All",
    label: "All",
  })
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      seasonTitle: (seasonPass && seasonPass.seasonTitle) || "",
      description: (seasonPass && seasonPass.description) || "",
      status: (seasonPass && seasonPass.status) || "",

      weekday:
        (seasonPass?.weekday || []).length > 0
          ? seasonPass?.weekday[0]
          : "00:00",
      weekdayend:
        (seasonPass?.weekday || []).length > 0
          ? seasonPass?.weekday[1]
          : "00:00",

      saturday:
        (seasonPass?.saturday || []).length > 0
          ? seasonPass?.saturday[0]
          : "00:00",
      saturdayend:
        (seasonPass?.saturday || []).length > 0
          ? seasonPass?.saturday[1]
          : "00:00",

      sunday:
        (seasonPass?.sunday || []).length > 0 ? seasonPass?.sunday[0] : "00:00",
      sundayend:
        (seasonPass?.sunday || []).length > 0 ? seasonPass?.sunday[1] : "00:00",

      special:
        (seasonPass?.specialday || []).length > 0
          ? seasonPass?.specialday[0]
          : "00:00",
      specialend:
        (seasonPass?.specialday || []).length > 0
          ? seasonPass?.specialday[1]
          : "00:00",
      //pricing: price,
      scheduleDate: convertUtcToLocal(getScheduleDate(seasonPass || null)),
      expiryDate: convertUtcToLocal(
        seasonPass?.expiryDate || defaultExpiryDate
      ),
      scheduleChangeDate: convertUtcToLocal(
        getScheduleChangeDate(seasonPass || null)
      ),
    },
    validationSchema: Yup.object({
      showExpiryDate: Yup.boolean(),
      seasonTitle: Yup.string()
        .required("Please Enter Your Name")
        .min(3, "Please Enter Minimum 3 chars"),
      //pricing: Yup.string().required("Please Enter Price"),
      scheduleDate: Yup.string().required("Please Enter Your Name"),
    }),
    onSubmit: values => {
      if (isEmpty(selectedSeasonType)) {
        setCustValidation({ ...customValidation, validSeasonType: false })
        return
      }
      if (isEmpty(selectedRole)) {
        setCustValidation({ ...customValidation, validRole: false })
        return
      }
      if (isEmpty(selectedCarpark)) {
        setCustValidation({ ...customValidation, validCarpark: false })
        return
      }
      if (
        liveStatus &&
        expiryStatus &&
        convertUtcToLocal(values["scheduleDate"], "YYYY-MM-DD") >=
          convertUtcToLocal(values["expiryDate"], "YYYY-MM-DD")
      ) {
        toastr.error(
          "Expiry date should not be less than or equal to live date!",
          ""
        )
        return
      }
      const _status = !liveStatus
        ? seasonPasstSatusTypes["Not-Available"]
        : liveStatus &&
          convertUtcToLocal(defaultDate, "YYYY-MM-DD") ==
            convertUtcToLocal(values["scheduleDate"], "YYYY-MM-DD")
        ? seasonPasstSatusTypes.Available
        : seasonPasstSatusTypes.Pending
      let seasonPassObj = {
        seasonTitle: values["seasonTitle"],
        weekday: isWeekdaysStatus
          ? [values["weekday"], values["weekdayend"]]
          : [],
        saturday: isSaturdayStatus
          ? [values["saturday"], values["saturdayend"]]
          : [],
        sunday: isSundayStatus ? [values["sunday"], values["sundayend"]] : [],
        specialday: isSpecialStatus
          ? [values["special"], values["specialend"]]
          : [],
        isWeekdaysStatus,
        isSaturdayStatus,
        isSundayStatus,
        isSpecialStatus,
        description: values["description"],
        roleApplicable: (selectedRole || []).map(el => el.value),
        seasonType: selectedSeasonType?.value || "",
        carParkApplicable: (selectedCarpark || []).map(el => el.value),
        expiryDate: expiryStatus
          ? convertDateToUtc(values["expiryDate"])
          : null,
        status: _status,
        scheduled: null,
        pricing: price,
        vehicleType: type,
      }
      if ((_status == "Pending" || scheduleChange) && isEdit) {
        let _scheduleObj = []
        if (seasonPass?.seasonTitle != seasonPassObj?.seasonTitle) {
          _scheduleObj.push({
            dateScheduled: scheduleChange
              ? convertDateToUtc(values["scheduleChangeDate"])
              : convertDateToUtc(values["scheduleDate"]),
            updateField: "seasonTitle",
            updateData: seasonPassObj?.seasonTitle,
          })
          delete seasonPassObj?.seasonTitle
        }
        if (seasonPass?.description != seasonPassObj?.description) {
          _scheduleObj.push({
            dateScheduled: scheduleChange
              ? convertDateToUtc(values["scheduleChangeDate"])
              : convertDateToUtc(values["scheduleDate"]),
            updateField: "description",
            updateData: seasonPassObj?.description,
          })
          delete seasonPassObj?.description
        }
        if (seasonPass?.roleApplicable != seasonPassObj?.roleApplicable) {
          _scheduleObj.push({
            dateScheduled: scheduleChange
              ? convertDateToUtc(values["scheduleChangeDate"])
              : convertDateToUtc(values["scheduleDate"]),
            updateField: "roleApplicable",
            updateData: seasonPassObj?.roleApplicable,
          })
          delete seasonPassObj?.roleApplicable
        }
        if (seasonPass?.carParkApplicable != seasonPassObj?.carParkApplicable) {
          _scheduleObj.push({
            dateScheduled: scheduleChange
              ? convertDateToUtc(values["scheduleChangeDate"])
              : convertDateToUtc(values["scheduleDate"]),
            updateField: "carParkApplicable",
            updateData: seasonPassObj?.carParkApplicable,
          })
          delete seasonPassObj?.carParkApplicable
        }
        if (seasonPass?.pricing != seasonPassObj?.pricing) {
          _scheduleObj.push({
            dateScheduled: scheduleChange
              ? convertDateToUtc(values["scheduleChangeDate"])
              : convertDateToUtc(values["scheduleDate"]),
            updateField: "pricing",
            updateData: seasonPassObj?.pricing,
          })
          _scheduleObj.push({
            dateScheduled: scheduleChange
              ? convertDateToUtc(values["scheduleChangeDate"])
              : convertDateToUtc(values["scheduleDate"]),
            updateField: "seasonType",
            updateData: seasonPassObj?.seasonType,
          })
          delete seasonPassObj?.pricing
          delete seasonPassObj?.seasonType
        }

        if (
          moment(seasonPass?.expiryDate).format() !=
          seasonPassObj?.expiryDate
        ) {
          _scheduleObj.push({
            dateScheduled: scheduleChange
              ? convertDateToUtc(values["scheduleChangeDate"])
              : convertDateToUtc(values["scheduleDate"]),
            updateField: "expirtyDate",
            updateData: seasonPassObj?.expiryDate,
          })
          delete seasonPassObj?.expiryDate
        }
        seasonPassObj = {
          ...seasonPassObj,
          //status: statusTypes.Pending,
          scheduled: _scheduleObj,
        }
      } else if (_status == "Pending" && !isEdit) {
        seasonPassObj = {
          ...seasonPassObj,
          scheduled: [
            {
              dateScheduled: convertDateToUtc(values["scheduleDate"]),
              updateField: "status",
              updateData: "Available",
            },
          ],
        }
      }

      if (isEdit) {
        seasonPassObj = {
          ...seasonPassObj,
          id: seasonPass.id,
        }
        dispatch(onUpdateSeasonPass(seasonPassObj))
      } else {
        dispatch(onAddNewSeasonPass(seasonPassObj))
      }
      toggle()
    },
  })

  const { seasonPassData, roleList, carParkList, message, pagination, error } =
    useSelector(state => ({
      seasonPassData: state.seasonPass.seasonPassList,
      pagination: state.seasonPass.pagination,
      message: state.seasonPass.message,
      error: state.seasonPass.error,
      roleList: state.roles.roleList,
      carParkList: state.carPark.carParkList,
    }))
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [selectedRole, setSelectedRole] = useState(
    getSelectedRoles(seasonPass || null)
  )
  const [selectedCarpark, setSelectedCarpark] = useState(
    getSelectedSeasonPass(seasonPass || null)
  )
  const [selectedSeasonType, setSeasonType] = useState(
    getSeasonType(seasonPass)
  )

  const [liveStatus, setLiveStatus] = useState(true)
  const [scheduleChange, setScheduleChange] = useState(false)
  const [page, setPage] = useState(pagination?.currentPage || 1)
  const [customValidation, setCustValidation] = useState({
    validRole: true,
    validCarpark: true,
    validSeasonType: true,
  })
  const [isWeekdaysStatus, setIsWeekdaysStatus] = useState(false)
  const [isSaturdayStatus, setIsSaturdayStatus] = useState(false)
  const [isSundayStatus, setIsSundayStatus] = useState(false)
  const [isSpecialStatus, setIsSpecialStatus] = useState(false)

  const pageOptions = {
    sizePerPage: sizePerPage,
    totalSize: seasonPassData?.length || sizePerPage,
    custom: true,
  }
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc", // desc or asc
    },
  ]

  const spListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: seasonPass => <>{seasonPass._id}</>,
    },
    {
      text: "Season Title",
      dataField: "name",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, seasonPass) => {
        let carparks = (seasonPass.carparks || []).map(
          el => el?.carParkShortCode || ""
        )
        //let carparkStr = carparks.join().replace(/,\s*$/, "")
        return (
          <>
            <h5 className="font-size-14 mb-1">
              <Link to="#" className="text-dark">
                {seasonPass.seasonTitle}
              </Link>
            </h5>
            <div
              className="avtar-row"
              style={{ display: "flex", flexDirection: "row" }}
            >
              {(seasonPass.carparks || []).map(
                el =>
                  el?.carParkTitle != "" && (
                    <Badge key={el._id} className="bg-success me-1">
                      {`${el?.carParkShortCode || ""}`}
                    </Badge>
                  )
              )}
            </div>
          </>
        )
      },
    },
    {
      dataField: "vehicleType",
      text: "Vehicle Type",
      sort: true,
      formatter: (cellContent, seasonPass) => {
        const type =
          seasonPass.vehicleType == vehicleTypes.car
            ? "Car"
            : seasonPass.vehicleType == vehicleTypes.bike
            ? "Bike"
            : ""
        return type
      },
    },
    {
      dataField: "pricing",
      text: "Pricing",
      sort: true,
      formatter: (cellContent, seasonPass) => {
        const type =
          seasonPass.seasonType == seasonTypes.Daily
            ? "Day"
            : seasonPass.seasonType == seasonTypes.Monthly
            ? "Month"
            : seasonPass.seasonType == seasonTypes["N/A"] ? "N/A" : ""
        return (
          <>
            {type != "" ? `$${seasonPass.pricing} / ${type} ` : "Complimentary"}
          </>
        )
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, seasonPass) => {
        return (
          <Badge className={"bg-" + getColor(seasonPass?.status)}>
            {seasonPass?.status == seasonPasstSatusTypes.Approved ||
            seasonPass?.status == seasonPasstSatusTypes.Available
              ? "Live"
              : seasonPass?.status}
          </Badge>
        )
      },
    },
    {
      dataField: "applicableRoles",
      text: "Applicable Roles",
      sort: true,
      formatter: (cellContent, seasonPass) => {
        return (
          <div
            className="avtar-row"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {(seasonPass.roles || []).map(el => (
              <Badge key={el._id} color="primary" className={"m-1 p-1"}>
                {el?.roleTitle || ""}
              </Badge>
            ))}
          </div>
        )
      },
    },

    {
      dataField: "description",
      text: "Season Description",
      sort: true,
      formatter: (cellContent, seasonPass) => {
        return (
          <div style={{ whiteSpace: "normal", width: 300 }}>
            {seasonPass?.description || ""}
          </div>
        )
      },
    },
    {
      dataField: "seasonId",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, seasonPass) => {
        return (
          <div
            className="d-flex gap-3"
            style={{
              opacity:
                seasonPass?.status == seasonPasstSatusTypes.Removed ? "0.4" : 5,
              pointerEvents:
                seasonPass?.status == seasonPasstSatusTypes.Removed
                  ? "none"
                  : "auto",
            }}
          >
            <>
              <Link className="primary" to="#">
                <i
                  className="mdi mdi-puzzle-edit font-size-24"
                  id="edittooltip"
                  onClick={() => handleSeasonPassEdit(seasonPass)}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Update Season Pass"
                ></i>
              </Link>
              <Link
                className={
                  seasonPass?.status == "Not-Available"
                    ? "text-success"
                    : "text-black"
                }
                to="#"
              >
                <i
                  className={
                    seasonPass?.status == "Not-Available"
                      ? "mdi mdi-puzzle-check font-size-24"
                      : "mdi mdi-puzzle-remove font-size-24"
                  }
                  id="edittooltip"
                  onClick={e => handleChangeStatus(seasonPass)}
                  data-toggle="tooltip"
                  data-placement="top"
                  title={
                    seasonPass?.status == "Not-Available"
                      ? "Live Season Pass"
                      : "Unlive Season Pass"
                  }
                ></i>
              </Link>
              <Link className="text-danger" to="#">
                <i
                  className="mdi mdi-puzzle-minus font-size-24"
                  id="deletetooltip"
                  onClick={() => onClickDelete(seasonPass)}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Remove Season Pass"
                ></i>
              </Link>
            </>
          </div>
        )
      },
    },
  ]

  useEffect(() => {
    if (isEmpty(roleList)) {
      dispatch(onGetRoles({ status: [`${seasonPasstSatusTypes.Available}`] }))
    }
    if (isEmpty(carParkList)) {
      dispatch(
        onGetCarparks({
          status: [
            seasonPasstSatusTypes.Available,
            seasonPasstSatusTypes.Approved,
          ],
        })
      )
    }
    dispatch(onGetSeasonPasses())
  }, [])

  useMemo(() => {
    if (message) {
      toastr.success(message, messageTitle)
      dispatch(onGetSeasonPasses())
      setTimeout(() => {
        dispatch(clearMessage())
        resetForm()
      }, 500)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  const toggle = () => {
    // if (!!isEdit) {
    //   setIsSaturdayStatus(false)
    //   setIsWeekdaysStatus(false)
    //   setIsSundayStatus(false)
    //   setIsSpecialStatus(false)
    // }
    setModal(!modal)
  }

  const handleChangeStatus = seasonPass => {
    setSeasonPass({ ...seasonPass, action: "change-status" })
    setDeleteModal(true)
  }

  const handleSeasonPassEdit = arg => {
    const _seasonPass = arg
    setSeasonPass({
      ..._seasonPass,
      id: _seasonPass._id,
      seasonTitle: _seasonPass.seasonTitle,
      description: _seasonPass.description,
      expiryDate: _seasonPass.expiryDate,
      scheduled: _seasonPass.scheduled,
    })
    setPricing(_seasonPass?.pricing || 0)
    setSeasonType(getSeasonType(_seasonPass))
    setSelectedRole(getSelectedRoles(_seasonPass || null))
    setSelectedCarpark(getSelectedSeasonPass(_seasonPass || null))
    setLiveStatus(_seasonPass?.status != seasonPasstSatusTypes["Not-Available"])
    setExpiryStatus(!isEmpty(_seasonPass?.expiryDate))
    setIsWeekdaysStatus(
      _seasonPass?.weekday && _seasonPass?.weekday[0] ? true : false
    )
    setIsSaturdayStatus(
      _seasonPass?.saturday && _seasonPass?.saturday[0] ? true : false
    )
    setIsSundayStatus(
      _seasonPass?.sunday && _seasonPass?.sunday[0] ? true : false
    )
    setIsSpecialStatus(
      _seasonPass?.specialday && _seasonPass?.specialday[0] ? true : false
    )
    setIsEdit(true)

    // setIsWeekdaysStatus((seasonPass && seasonPass.weekday && seasonPass.weekday[0]) ? true : false);
    // setIsSundayStatus((seasonPass && seasonPass.sunday && seasonPass.sunday[0]) ? true : false);

    if (_seasonPass.vehicleType == vehicleTypes.bike) {
      setType(vehicleTypes.bike)
    } else {
      setType(vehicleTypes.car)
    }
    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = seasonPass => {
    setSeasonPass({ ...seasonPass, action: "delete" })
    setDeleteModal(true)
  }

  const handleBlockClick = role => {
    if (role?.status == "Not-Available") {
      setSelectedRole({ ...role, action: "Available" })
    } else {
      setSelectedRole({ ...role, action: "Not-Available" })
    }
    setDeleteModal(true)
  }

  const handleDeleteSeasonPass = () => {
    if (seasonPass.action == "change-status") {
      let seasonPassObj = {
        id: seasonPass._id,
        status:
          seasonPass?.status == seasonPasstSatusTypes["Not-Available"]
            ? seasonPasstSatusTypes.Available
            : seasonPasstSatusTypes["Not-Available"],
      }
      dispatch(onUpdateSeasonPass(seasonPassObj))
    } else {
      dispatch(onDeleteSeasonPass(seasonPass))
    }

    onPaginationPageChange(1)
    setDeleteModal(false)
  }

  const resetForm = () => {
    setType(vehicleTypes.car)
    setSeasonPass({
      seasonTitle: "",
      description: "",
      seasonType: "",
      pricing: "",
      expiryDate: "",
      scheduleDate: "",
      status: "",
    })
    setPricing(0)
    setSelectedCarpark([])
    setSeasonType("")
    setSelectedRole([])
    setLiveStatus(true)
    setExpiryStatus(false)
    setIsSaturdayStatus(false)
    setIsWeekdaysStatus(false)
    setIsSundayStatus(false)
    setIsSpecialStatus(false)
    setCustValidation({
      validCarpark: true,
      validRole: true,
      validSeasonType: true,
    })
  }

  const handleSeasonPassAdd = () => {
    resetForm()
    validation.resetForm()
    setIsEdit(false)
    toggle()
  }

  const handleFilter = e => {
    setFilterStatus(e)
    if (e.value == "All") {
      dispatch(onGetSeasonPasses())
    } else {
      dispatch(onGetSeasonPasses({ status: e.value }))
    }
  }

  const keyField = "_id"

  const roleOptions = (roleList || []).map(el => ({
    value: el._id,
    label: el.roleTitle,
  }))

  const carParkOptions = (carParkList || []).map(el => ({
    value: el._id,
    label: el.carParkTitle,
  }))

  const seasonTypeOptions = map(seasonTypes, (key, i) => {
    return {
      value: `${key}`,
      label: `${seasonTypes[key]}`,
    }
  })

  delete seasonPasstSatusTypes.Offline
  delete seasonPasstSatusTypes.Blacklist
  delete seasonPasstSatusTypes.Rejected
  delete seasonPasstSatusTypes.Approved

  let statusTypeOptions = map(seasonPasstSatusTypes, (key, i) => {
    return {
      value: `${key}`,
      label: `${seasonPasstSatusTypes[key]}`,
    }
  })
  statusTypeOptions.unshift({ value: "All", label: "All" })

  const _scheduleDate = validation.values.scheduleDate
    ? moment(validation.values.scheduleDate).format(dateformat.default)
    : ""
  const _expiryDate = validation.values.expiryDate
    ? moment(validation.values.expiryDate).format(dateformat.default)
    : ""

  const _scheduleChangeDate = validation.values.scheduleChangeDate
    ? moment(validation.values.scheduleChangeDate).format(dateformat.default)
    : ""

  const minExpiryDate = moment(_expiryDate).format(dateformat.default)

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteSeasonPass}
        onCloseClick={() => setDeleteModal(false)}
        text={
          seasonPass?.action == "delete"
            ? "Yes, delete it!"
            : seasonPass?.action == "change-status" &&
              seasonPass.status == seasonPasstSatusTypes["Not-Available"]
            ? "Yes, live it!"
            : "Yes, unlive it!"
        }
        icon={
          seasonPass?.action == "delete"
            ? "mdi mdi-puzzle-remove"
            : seasonPass?.action == "change-status" &&
              seasonPass.status == seasonPasstSatusTypes["Not-Available"]
            ? "mdi mdi-puzzle-check"
            : "mdi mdi-puzzle"
        }
        iconColor={
          seasonPass?.action == "delete"
            ? "text-danger"
            : seasonPass?.action == "change-status" &&
              seasonPass.status == seasonPasstSatusTypes["Not-Available"]
            ? "text-success"
            : "text-dark"
        }
        bodyText={
          seasonPass?.action == "delete"
            ? `Remove Season Pass: ${seasonPass?.seasonTitle}!`
            : seasonPass?.action == "change-status" &&
              seasonPass.status == seasonPasstSatusTypes["Not-Available"]
            ? `Live Season Pass: ${seasonPass?.seasonTitle}!`
            : `Unlive Season Pass: ${seasonPass?.seasonTitle}!`
        }
      />

      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              {/* <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={spListColumns}
                data={seasonPassData}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return ( */}
                    <ToolkitProvider
                      keyField={keyField}
                      data={seasonPassData}
                      columns={spListColumns}
                      bootstrap4
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="4">
                              <Select
                                placeholer={"Select status"}
                                name={"statusType"}
                                value={filterStatus}
                                onChange={e => {
                                  handleFilter(e)
                                }}
                                options={statusTypeOptions}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                            <Col sm="8">
                              <div className="text-sm-end">
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={handleSeasonPassAdd}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add New Season Pass
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  // {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                />

                                <Modal
                                  isOpen={modal}
                                  toggle={toggle}
                                  className={"modal-lg"}
                                >
                                  <ModalHeader toggle={toggle} tag="h4">
                                    {!!isEdit
                                      ? "Update Season Pass"
                                      : "Add Season Pass"}
                                  </ModalHeader>
                                  <ModalBody>
                                    <Form
                                      onSubmit={e => {
                                        e.preventDefault()
                                        validation.handleSubmit()
                                        return false
                                      }}
                                    >
                                      {/* <FormGroup className="mb-2" row>
                                        <Col md={6}>
                                          <div>
                                            <Label className="form-label">
                                              Live
                                            </Label>
                                            <Row className="mb-2">
                                              <Col md={2} className="pr-0">
                                                <Switch
                                                  checked={liveStatus}
                                                  onColor="#626ed4"
                                                  onChange={e => {
                                                    setLiveStatus(!liveStatus)
                                                  }}
                                                  uncheckedIcon={
                                                    <OffSymbol text="Off" />
                                                  }
                                                  checkedIcon={
                                                    <OnSymbol text="On" />
                                                  }
                                                />
                                              </Col>
                                              {liveStatus && (
                                                <Col md={10} className="pl-0">
                                                  <input
                                                    className="form-control"
                                                    type="date"
                                                    defaultValue={_scheduleDate}
                                                    id="scheduleDate"
                                                    name="scheduleDate"
                                                    min={moment().format(
                                                      "YYYY-MM-DD"
                                                    )}
                                                    onChange={
                                                      validation.handleChange
                                                    }
                                                    onBlur={
                                                      validation.handleBlur
                                                    }
                                                    invalid={
                                                      validation.touched
                                                        .scheduleDate &&
                                                      validation.errors
                                                        .scheduleDate
                                                        ? true
                                                        : false
                                                    }
                                                    disabled={
                                                      liveStatus &&
                                                      isEdit &&
                                                      (seasonPass?.status ==
                                                        seasonPasstSatusTypes.Available ||
                                                        seasonPass?.status ==
                                                          seasonPasstSatusTypes.Approved)
                                                    }
                                                  />
                                                  {validation.touched
                                                    .scheduleDate &&
                                                  validation.errors
                                                    .scheduleDate ? (
                                                    <FormFeedback type="invalid">
                                                      {
                                                        validation.errors
                                                          .scheduleDate
                                                      }
                                                    </FormFeedback>
                                                  ) : null}
                                                </Col>
                                              )}
                                            </Row>
                                          </div>
                                        </Col>
                                        <Col md={6}>
                                          <div>
                                            <label className="form-label">
                                              Expiry Date
                                            </label>
                                            <Row className="mb-2">
                                              <Col md={2} className="pr-0">
                                                <Switch
                                                  checked={expiryStatus}
                                                  onColor="#626ed4"
                                                  onChange={() =>
                                                    setExpiryStatus(
                                                      !expiryStatus
                                                    )
                                                  }
                                                  uncheckedIcon={
                                                    <OffSymbol text="Off" />
                                                  }
                                                  checkedIcon={
                                                    <OnSymbol text="On" />
                                                  }
                                                />
                                              </Col>
                                              {expiryStatus && (
                                                <Col md={10} className="pl-0">
                                                  <input
                                                    className="form-control"
                                                    type="date"
                                                    defaultValue={_expiryDate}
                                                    min={minExpiryDate}
                                                    id="expiryDate"
                                                    name="expiryDate"
                                                    onChange={
                                                      validation.handleChange
                                                    }
                                                    onBlur={
                                                      validation.handleBlur
                                                    }
                                                    invalid={
                                                      validation.touched
                                                        .expiryDate &&
                                                      validation.errors
                                                        .expiryDate
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                  {validation.touched
                                                    .expiryDate &&
                                                  validation.errors
                                                    .expiryDate ? (
                                                    <FormFeedback type="invalid">
                                                      {
                                                        validation.errors
                                                          .expiryDate
                                                      }
                                                    </FormFeedback>
                                                  ) : null}
                                                </Col>
                                              )}
                                            </Row>
                                          </div>
                                        </Col>
                                      </FormGroup> */}
                                      <Row form>
                                        <Col xs={12}>
                                          {/* {!isEmpty(seasonPass) &&
                                            (seasonPass?.status ==
                                              statusTypes.Approved ||
                                              seasonPass?.status ==
                                                statusTypes.Available) && (
                                              <div className="mb-3">
                                                <Label className="col-form-label">
                                                  Schedule Change
                                                </Label>
                                                <Row className="mb-2">
                                                  <Col md={2} className="pr-0">
                                                    <Switch
                                                      checked={scheduleChange}
                                                      onColor="#626ed4"
                                                      onChange={e => {
                                                        setScheduleChange(
                                                          !scheduleChange
                                                        )
                                                      }}
                                                      uncheckedIcon={
                                                        <OffSymbol text="Off" />
                                                      }
                                                      checkedIcon={
                                                        <OnSymbol text="On" />
                                                      }
                                                    />
                                                  </Col>
                                                  {scheduleChange && (
                                                    <Col
                                                      md={10}
                                                      className="pl-0"
                                                    >
                                                      <input
                                                        className="form-control"
                                                        type="date"
                                                        defaultValue={
                                                          _scheduleChangeDate
                                                        }
                                                        id="scheduleChangeDate"
                                                        name="scheduleChangeDate"
                                                        min={moment().format(
                                                          "YYYY-MM-DD"
                                                        )}
                                                        onChange={
                                                          validation.handleChange
                                                        }
                                                        onBlur={
                                                          validation.handleBlur
                                                        }
                                                        invalid={
                                                          validation.touched
                                                            .scheduleChangeDate &&
                                                          validation.errors
                                                            .scheduleChangeDate
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                      {validation.touched
                                                        .scheduleChangeDate &&
                                                      validation.errors
                                                        .scheduleChangeDate ? (
                                                        <FormFeedback type="invalid">
                                                          {
                                                            validation.errors
                                                              .scheduleChangeDate
                                                          }
                                                        </FormFeedback>
                                                      ) : null}
                                                    </Col>
                                                  )}
                                                </Row>
                                              </div>
                                            )} */}
                                          <div className="mb-3">
                                            <Label className="form-label">
                                              Season Title*
                                            </Label>

                                            <Input
                                              name="seasonTitle"
                                              type="text"
                                              onChange={validation.handleChange}
                                              onBlur={validation.handleBlur}
                                              value={
                                                validation.values.seasonTitle ||
                                                ""
                                              }
                                              invalid={
                                                validation.touched
                                                  .seasonTitle &&
                                                validation.errors.seasonTitle
                                                  ? true
                                                  : false
                                              }
                                            />
                                            {validation.touched.seasonTitle &&
                                            validation.errors.seasonTitle ? (
                                              <FormFeedback type="invalid">
                                                {validation.errors.seasonTitle}
                                              </FormFeedback>
                                            ) : null}
                                          </div>
                                          <div className="mb-3">
                                            <Label className="form-label">
                                              Season Description
                                            </Label>
                                            <textarea
                                              name="description"
                                              className="form-control"
                                              id="description"
                                              rows="3"
                                              onChange={validation.handleChange}
                                              onBlur={validation.handleBlur}
                                              value={
                                                validation.values.description ||
                                                ""
                                              }
                                            ></textarea>
                                          </div>
                                          <div className="mb-3">
                                            <Row>
                                              <Col md={4}>
                                                <Row>
                                                  <Col>
                                                    <div className="form-check mt-4 mb-1">
                                                      <input
                                                        type="radio"
                                                        id="customRadio1"
                                                        name="customRadio"
                                                        className="form-check-input"
                                                        defaultChecked={
                                                          type ==
                                                          vehicleTypes.car
                                                        }
                                                        onChange={e =>
                                                          setType(
                                                            vehicleTypes.car
                                                          )
                                                        }
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor="customRadio1"
                                                      >
                                                        Car
                                                      </label>
                                                    </div>
                                                  </Col>
                                                  <Col>
                                                    <div className="form-check mt-4">
                                                      <input
                                                        type="radio"
                                                        id="customRadio2"
                                                        name="customRadio"
                                                        className="form-check-input"
                                                        defaultChecked={
                                                          type ==
                                                          vehicleTypes.bike
                                                        }
                                                        onChange={e =>
                                                          setType(
                                                            vehicleTypes.bike
                                                          )
                                                        }
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor="customRadio2"
                                                      >
                                                        Bike
                                                      </label>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col md={4}>
                                                <Label className="form-label">
                                                  Season Type
                                                </Label>
                                                <Select
                                                  name={"seasonType"}
                                                  value={selectedSeasonType}
                                                  onChange={e => {
                                                    setCustValidation({
                                                      ...customValidation,
                                                      validSeasonType: true,
                                                    })
                                                    setSeasonType(e)
                                                    if (
                                                      e.value == "N/A" ||
                                                      e.value == "Complimentary"
                                                    ) {
                                                      setPricing(0)
                                                    }
                                                  }}
                                                  options={seasonTypeOptions}
                                                  classNamePrefix="select2-selection"
                                                />
                                                {!customValidation.validSeasonType && (
                                                  <div
                                                    className="invalid-feedback"
                                                    style={{ display: "block" }}
                                                  >
                                                    Please select season type
                                                  </div>
                                                )}
                                              </Col>
                                              <Col md={4}>
                                                <Label className="form-label">
                                                  Price
                                                </Label>
                                                <Input
                                                  name="pricing"
                                                  placeholder="0.00"
                                                  type="number"
                                                  min="0"
                                                  step="0.01"
                                                  pattern="^\d+(?:\.\d{1,2})?$"
                                                  onChange={e =>
                                                    setPricing(e.target.value)
                                                  }
                                                  value={price}
                                                  invalid={
                                                    validation.touched
                                                      .pricing &&
                                                    validation.errors.pricing
                                                      ? true
                                                      : false
                                                  }
                                                  disabled={
                                                    selectedSeasonType?.value ==
                                                      "N/A" ||
                                                    selectedSeasonType?.value ==
                                                      "Complimentary"
                                                  }
                                                />
                                              </Col>
                                              {/* <Col md={2}>
                                                <Label className="form-label">
                                                  Invite Guest
                                                </Label>
                                                <p>
                                                  <Switch
                                                    checked={true}
                                                    onColor="#626ed4"
                                                    // onChange={e => {
                                                    //   setScheduleChange(
                                                    //     !scheduleChange
                                                    //   )
                                                    // }}
                                                    uncheckedIcon={
                                                      <OffSymbol text="Off" />
                                                    }
                                                    checkedIcon={
                                                      <OnSymbol text="On" />
                                                    }
                                                    readOnly
                                                  />
                                                </p>
                                              </Col> */}
                                            </Row>
                                          </div>

                                          <div className="mb-3">
                                            <label className="form-label">
                                              Applicable Roles
                                            </label>
                                            <Select
                                              name="role"
                                              isMulti
                                              closeMenuOnSelect={false}
                                              value={selectedRole}
                                              onChange={e => {
                                                setCustValidation({
                                                  ...customValidation,
                                                  validRole: true,
                                                })
                                                setSelectedRole(e)
                                              }}
                                              options={roleOptions}
                                              classNamePrefix="select2-selection"
                                            />
                                            {!customValidation.validRole && (
                                              <div
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                              >
                                                Please select at least one
                                                applicable role
                                              </div>
                                            )}
                                          </div>
                                          <div className="mb-3">
                                            <label className="form-label">
                                              Applicable Carparks
                                            </label>
                                            <Select
                                              isMulti
                                              closeMenuOnSelect={false}
                                              name={"carParkApplicable"}
                                              value={selectedCarpark}
                                              onChange={e => {
                                                setCustValidation({
                                                  ...customValidation,
                                                  validCarpark: true,
                                                })
                                                setSelectedCarpark(e)
                                              }}
                                              options={carParkOptions}
                                              classNamePrefix="select2-selection"
                                            />
                                            {!customValidation.validCarpark && (
                                              <div
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                              >
                                                Please select at least one
                                                applicable carpark
                                              </div>
                                            )}
                                          </div>
                                        </Col>
                                      </Row>
                                      {/* <Row>
                                        <Col md={12}>
                                          <label className="form-label">
                                            Weekdays
                                          </label>
                                          <Row>
                                            <Col md={2} className="pr-0">
                                              <Switch
                                                checked={
                                                  validation.values.weekday !==
                                                  null
                                                    ? isWeekdaysStatus
                                                    : false
                                                }
                                                onColor="#626ed4"
                                                onChange={() => {
                                                  setIsWeekdaysStatus(
                                                    !isWeekdaysStatus
                                                  )
                                                }}
                                                uncheckedIcon={
                                                  <OffSymbol text="Off" />
                                                }
                                                checkedIcon={
                                                  <OnSymbol text="On" />
                                                }
                                              />
                                            </Col>
                                            <Col md={5} className="pr-0">
                                              <input
                                                name="weekday"
                                                className="form-control d-block"
                                                placeholder="Select time"
                                                type="time"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                disabled={!isWeekdaysStatus}
                                                value={
                                                  validation.values.weekday ||
                                                  ""
                                                }
                                              />
                                            </Col>
                                            <Col md={5} className="pr-0">
                                              <input
                                                name="weekdayend"
                                                className="form-control d-block"
                                                placeholder="Select time"
                                                type="time"
                                                disabled={!isWeekdaysStatus}
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values
                                                    .weekdayend || ""
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row> */}
                                      {/* <Row>
                                        <Col md={12}>
                                          <label className="form-label">
                                            Saturday
                                          </label>
                                          <Row>
                                            <Col md={2}>
                                              <Switch
                                                checked={isSaturdayStatus}
                                                onColor="#626ed4"
                                                onChange={() => {
                                                  setIsSaturdayStatus(
                                                    !isSaturdayStatus
                                                  )
                                                }}
                                                uncheckedIcon={
                                                  <OffSymbol text="Off" />
                                                }
                                                checkedIcon={
                                                  <OnSymbol text="On" />
                                                }
                                              />
                                            </Col>
                                            <Col md={5} className="pr-0">
                                              <input
                                                name="saturday"
                                                className="form-control d-block"
                                                placeholder="Select time"
                                                type="time"
                                                disabled={!isSaturdayStatus}
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values.saturday ||
                                                  ""
                                                }
                                              />
                                            </Col>
                                            <Col md={5} className="pr-0">
                                              <input
                                                name="saturdayend"
                                                className="form-control d-block"
                                                placeholder="Select time"
                                                type="time"
                                                disabled={!isSaturdayStatus}
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values
                                                    .saturdayend || ""
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row> */}
                                      {/* <Row>
                                        <Col md={12}>
                                          <label className="form-label">
                                            Sunday
                                          </label>
                                          <Row>
                                            <Col md={2}>
                                              <Switch
                                                checked={isSundayStatus}
                                                onColor="#626ed4"
                                                onChange={() => {
                                                  setIsSundayStatus(
                                                    !isSundayStatus
                                                  )
                                                }}
                                                uncheckedIcon={
                                                  <OffSymbol text="Off" />
                                                }
                                                checkedIcon={
                                                  <OnSymbol text="On" />
                                                }
                                              />
                                            </Col>
                                            <Col md={5} className="pr-0">
                                              <input
                                                name="sunday"
                                                className="form-control d-block"
                                                placeholder="Select time"
                                                type="time"
                                                disabled={!isSundayStatus}
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values.sunday || ""
                                                }
                                              />
                                            </Col>
                                            <Col md={5} className="pr-0">
                                              <input
                                                name="sundayend"
                                                className="form-control d-block"
                                                placeholder="Select time"
                                                type="time"
                                                disabled={!isSundayStatus}
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values.sundayend ||
                                                  ""
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row> */}
                                      {/* <Row>
                                        <Col md={12}>
                                          <label className="form-label">
                                            Special Dates
                                          </label>
                                          <Row>
                                            <Col md={2}>
                                              <Switch
                                                checked={isSpecialStatus}
                                                onColor="#626ed4"
                                                onChange={() => {
                                                  setIsSpecialStatus(
                                                    !isSpecialStatus
                                                  )
                                                }}
                                                uncheckedIcon={
                                                  <OffSymbol text="Off" />
                                                }
                                                checkedIcon={
                                                  <OnSymbol text="On" />
                                                }
                                              />
                                            </Col>
                                            <Col md={5} className="pr-0">
                                              <input
                                                name="special"
                                                className="form-control d-block"
                                                placeholder="Select time"
                                                type="time"
                                                disabled={!isSpecialStatus}
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values.special ||
                                                  ""
                                                }
                                              />
                                            </Col>
                                            <Col md={5} className="pr-0">
                                              <input
                                                name="specialend"
                                                className="form-control d-block"
                                                placeholder="Select time"
                                                type="time"
                                                disabled={!isSpecialStatus}
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  validation.values
                                                    .specialend || ""
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row> */}
                                      <Row>
                                        <Col>
                                          <div className="text-end mt-4">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              {isEdit
                                                ? "Update Season Pass"
                                                : "Add Season Pass"}
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Form>
                                  </ModalBody>
                                </Modal>
                              </div>
                            </Col>
                          </Row>
                          {/* <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row> */}
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  {/* )
                }}
              </PaginationProvider> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default withRouter(SeasonPassList)
